export default __webpack_public_path__ + "static/market-index-treemap-5015bc7d5d4c777aecc8920f610172a1.png";